export enum EVisitationUrls {
  VISITATIONS = 'visitations',
  APPROVE = 'approve',
  REJECT = 'reject',
}
